import { AxiosResponse } from 'axios';
import { SET_BILLING_AND_INVOICINGS, SET_BILLING_AND_INVOICING, SET_BILLING_AND_INVOICING_STATS, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_BILLING_AND_INVOICING_ISLOADING,
  DELETE_BILLING_AND_INVOICING,
  DOWNLOAD_INVOICE_PDF,
  EDIT_BILLING_AND_INVOICING,
  GET_BILLING_AND_INVOICINGS,
  GET_BILLING_AND_INVOICING,
  GET_BILLING_AND_INVOICING_STATS,
  REGISTER_BILLING_AND_INVOICING,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import BillingInvoicing from '@/services/billing_invoicing';
import { Module } from 'vuex';
import { EditBillingInvoicing, RegisterBillingInvoicing, GetBillingInvoicing } from '@/dtos/billing_invoicing.dto';

const billingInvoicing: Module<any, {}> = {
  state: {
    billingInvoicing: {
      data: null,
      isLoading: false,
    },
    billingInvoicings: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    billingInvoicingStats: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    billingInvoicing: (state: { billingInvoicing: any }) => state.billingInvoicing,
    billingInvoicings: (state: { billingInvoicings: any }) => state.billingInvoicings,
    billingInvoicingStats: (state: { billingInvoicingStats: any }) => state.billingInvoicingStats,
  },
  mutations: {
    [SET_BILLING_AND_INVOICING]: (
      state: { billingInvoicing: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.billingInvoicing.data = payload.data) : null,
        (state.billingInvoicing.isLoading = payload.isLoading);
    },
    [SET_BILLING_AND_INVOICINGS]: (
      state: { billingInvoicings: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.billingInvoicings.data = payload.data) : null,
        payload.metaData != null ? (state.billingInvoicings.metaData = payload.metaData) : null,
        (state.billingInvoicings.isLoading = payload.isLoading);
    },
    [SET_BILLING_AND_INVOICING_STATS]: (
      state: { billingInvoicingStats: StateObject },
      payload: { data: null; isLoading: any }
    ) => {
      payload.data != null ? (state.billingInvoicingStats.data = payload.data) : null,
        (state.billingInvoicingStats.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_BILLING_AND_INVOICING]: async ({ commit }: any, payload: any) => {
      commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.registerBillingInvoicing(
        payload as RegisterBillingInvoicing
      );

      if (result) {
        if (result.data.status) {
          commit(SET_BILLING_AND_INVOICING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BILLING_AND_INVOICING, { isLoading: false });
        return false;
      }
    },
    [GET_BILLING_AND_INVOICINGS]: async ({ commit }: any, payload: any) => {
      commit(SET_BILLING_AND_INVOICINGS, { data: null, isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.getBillingInvoicings(
        payload as GetBillingInvoicing
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BILLING_AND_INVOICINGS, {
            data: result.data.data,
            metaData: result.data.metaData,
            isLoading: false,
          });
          return true;
        }
        commit(SET_BILLING_AND_INVOICINGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BILLING_AND_INVOICINGS, { isLoading: false });
        return false;
      }
    },
    [GET_BILLING_AND_INVOICING]: async ({ commit }: any, payload: any) => {
      commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.getBillingInvoicings(
        payload as GetBillingInvoicing
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BILLING_AND_INVOICING, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BILLING_AND_INVOICING, { isLoading: false });
        return false;
      }
    },
    [EDIT_BILLING_AND_INVOICING]: async ({ commit }: any, payload: any) => {
      commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.editBillingInvoicing(
        payload as EditBillingInvoicing
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BILLING_AND_INVOICING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BILLING_AND_INVOICING, { isLoading: false });
        return false;
      }
    },
    [DELETE_BILLING_AND_INVOICING]: async ({ commit }: any, payload: string) => {
      commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.deleteBillingInvoicing(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BILLING_AND_INVOICING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BILLING_AND_INVOICING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BILLING_AND_INVOICING, { isLoading: false });
        return false;
      }
    },
    [GET_BILLING_AND_INVOICING_STATS]: async ({ commit }: any, payload: { organizationId: string; projectId?: string }) => {
      commit(SET_BILLING_AND_INVOICING_STATS, { data: null, isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.getBillingInvoicingStats(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_BILLING_AND_INVOICING_STATS, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_BILLING_AND_INVOICING_STATS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BILLING_AND_INVOICING_STATS, { isLoading: false });
        return false;
      }
    },
    [CLEAR_BILLING_AND_INVOICING_ISLOADING]: ({ commit }) => {
      commit(SET_BILLING_AND_INVOICING, { isLoading: false });
      commit(SET_BILLING_AND_INVOICINGS, { isLoading: false });
    },
    [DOWNLOAD_INVOICE_PDF]: async ({ commit }: any, payload: string) => {
      commit(SET_BILLING_AND_INVOICING, { isLoading: true });

      const result: AxiosResponse = await BillingInvoicing.downloadInvoicePDF(payload);

      if (result) {
        commit(SET_BILLING_AND_INVOICING, { isLoading: false });
        return result;
      } else {
        commit(SET_BILLING_AND_INVOICING, { isLoading: false });
        return false;
      }
    },
  },
};

export default billingInvoicing;

